@if (isLoading) {
<app-loader></app-loader>
} @else {
<div class="px-10">
	<nz-page-header [nzTitle]="orderTitle" class="p-0 m-0 mt-10">

		<nz-page-header-tags>
			<div class="flex items-center w-full justify-between">
				<span [ngClass]="order.status?.cssClassName">
					{{ order.status?.name }}
				</span>
			</div>
		</nz-page-header-tags>
		<nz-breadcrumb nz-page-header-breadcrumb>
			<nz-breadcrumb-item>
				<a [routerLink]="'/production-orders'">
					<span>Órdenes</span>
				</a>
			</nz-breadcrumb-item>
			<nz-breadcrumb-item>
				<a [routerLink]="['/production-orders']" [queryParams]="{ customerName: order.customers?.name }">
					<span>{{ order.customers?.name }}</span>
				</a>
			</nz-breadcrumb-item>
			<nz-breadcrumb-item>Orden {{ idValueToShow }} - {{ order.description }}</nz-breadcrumb-item>
		</nz-breadcrumb>
		<nz-page-header-content>
			<nz-descriptions nzSize="small" [nzColumn]="{ xxl: 4, xl: 4, lg: 3, md: 3, sm: 2, xs: 1 }">
				<nz-descriptions-item nzTitle="Núm. Orden" [nzSpan]="1"><b>{{ idValueToShow
						}}</b></nz-descriptions-item>
				<nz-descriptions-item nzTitle="Referencia" [nzSpan]="1"><b>{{ order.reference || 'Sin referencia'
						}}</b></nz-descriptions-item>
				<nz-descriptions-item nzTitle="Ruta" [nzSpan]="1">
					<b>{{
						order.productionRoute
						? order.productionRoute!.name
						: "SIN RUTA"
						}}</b>
				</nz-descriptions-item>
				<nz-descriptions-item nzTitle="Prioridad" [nzSpan]="1">
					<span [class]="order.priority?.cssClassName">
						{{ order.priority?.name }}
					</span>
				</nz-descriptions-item>
				<nz-descriptions-item nzTitle="Fecha" [nzSpan]="1"><b>{{
						order.startDate | date: "dd/MM/YYYY"
						}}</b></nz-descriptions-item>
				<nz-descriptions-item nzTitle="Fecha fin" [nzSpan]="1">
					<b>{{
						order.deadlineDate
						? (order.deadlineDate | date: "dd/MM/YYYY")
						: "Sin fecha de fin"
						}}</b>
				</nz-descriptions-item>
				<nz-descriptions-item nzTitle="Fecha de confirmación" [nzSpan]="1"><b>{{ order.confirmationDate | date:
						"dd/MM/YYYY"
						}}</b></nz-descriptions-item>
				<nz-descriptions-item nzTitle="Fecha de entrega" [nzSpan]="1"><b>{{ order.deliveryDate | date:
						"dd/MM/YYYY"
						}}</b></nz-descriptions-item>
				<nz-descriptions-item nzTitle="Cliente" [nzSpan]="2"><b>{{ order.customers?.name
						}}</b></nz-descriptions-item>
				<nz-descriptions-item nzTitle="Descripción" [nzSpan]="2"><b>{{ order.description
						}}</b></nz-descriptions-item>
			</nz-descriptions>
		</nz-page-header-content>
	</nz-page-header>

	<div class="mt-12 pb-20">
		<div class="flex items-center mb-5">
			<svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg">
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
					d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
			</svg>
			<p class="text-[15px] font-semibold p-0 m-0">
				Procesos productivos
			</p>
		</div>
		<nz-table #processesTable [nzData]="order.productionOrderProcesses ? order.productionOrderProcesses : []"
			[nzBordered]="true" nzSize="small" [nzFrontPagination]="false" [nzShowPagination]="false"
			[nzScroll]="{ x:'240px' }">
			<thead>
				<tr>
					<th nzWidth="50px">Nº</th>
					<th nzWidth="250px">Proceso</th>
					<!-- <th>Procesos Hijos</th> -->
					<th nzWidth="130px">Estado</th>
					<th nzWidth="300px">Máquina</th>
					<th nzWidth="130px">Inicio</th>
					<th nzWidth="130px">Fin</th>
					<th nzWidth="130px">Duración</th>
					<th nzWidth="100px">Progreso</th>
					<th nzRight nzWidth="125px">Acciones</th>
				</tr>
			</thead>
			<tbody>
				@for (process of processesTable.data; track process; let i = $index) {
				<tr>
					<td class="text-right align-middle">
						{{ process.order }}
					</td>
					<td>
						{{ process.productionProcess!.name }}
					</td>
					<!-- <td class="uppercase align-middle">
						<p>MOSTRAR STRING CON LOS PROCESOS HIJOS</p>
					</td> -->
					<td class="text-center align-middle">
						<span [ngClass]="process.status?.cssClassName">
							{{ process.status?.name ?? '' }}
						</span>
					</td>
					<td class="uppercase">
						{{
						process?.machine
						? process.machine!.name
						: "Cualquiera de " +
						process.productionProcess!.name
						}}
					</td>
					<td class="capitalize">
						{{
						!process.productionTime
						? "-"
						: (process.productionTime.startDate
						| date: ("dd/MM/YYYY HH:mm:ss"))}}
					</td>
					<td class="capitalize">
						{{
						!process.productionTime ||
						process.productionTime.endDate === null
						? "-"
						: (process.productionTime.endDate
						| date: ("dd/MM/YYYY HH:mm:ss"))}}
					</td>
					<td class="capitalize">
						{{
						!process.productionTime ||
						process.productionTime.endDate === null
						? "-"
						: getTotalTime(process)
						}}
					</td>

					<td style="width: 140px !important; text-overflow: ellipsis">
						<nz-progress [nzPercent]="calculateProcessProgress(process)" nzSize="small"></nz-progress>
					</td>

					<td nzRight>
						<div class="flex align-middle justify-center">
							@if (canReadProductionOrderProcessDetail()) {
							<button nz-button nzType="text" nzShape="circle" class="table-icon"
								[nzTooltipTitle]="'Ver detalle ' + process.productionProcess!.name"
								nzTooltipPlacement="bottom" nz-tooltip
								(click)="canReadProductionOrderProcessDetail() ? navigateToOperacion(process.id!) : ''">
								<span nz-icon nzType="fund-view"></span>
							</button>
							@if (!process.status!.isEndingStatus!) {
							<nz-divider nzType="vertical"></nz-divider>
							}
							}
							@if (!process.status!.isEndingStatus!) {
							<button nz-button nzType="text" nzShape="circle" class="table-icon"
								[nzTooltipTitle]="'Forzar finalizar del proceso ' + process.productionProcess!.name"
								nzTooltipPlacement="bottom" nz-tooltip (click)="forceFinishProduction(process)">
								<span nz-icon nzType="file-done"></span>
							</button>
							}
						</div>
					</td>
				</tr>
				}
			</tbody>
		</nz-table>
	</div>

	@if (order.productionOrderProcesses && order.productionOrderProcesses.length > 1 ) {
	<div class="mt-12">
		<div class="flex items-center mb-5 justify-between">
			<div class="flex items-center">
				<svg class="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24"
					xmlns="http://www.w3.org/2000/svg">
					<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
						d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
				</svg>
				<p class="text-[15px] font-semibold p-0 m-0">
					Bifurcaciones de la orden
				</p>
			</div>
			<div class="flex items-center">
				<label nz-checkbox [(ngModel)]="zoomEnabled">Activar zoom</label>
				<button nz-button class="flex items-center font-medium rounded-md ml-2" (click)="center$.next(true)">
					Centrar
				</button>
			</div>
		</div>

		<div class="items-center max-w-full">
			<div class="tree">
				<ngx-graph [links]="links" [nodes]="nodes" [clusters]="clusters" [layout]="layout" [curve]="curve"
					[draggingEnabled]="draggingEnabled" [panningEnabled]="panningEnabled" [enableZoom]="zoomEnabled"
					[zoomSpeed]="zoomSpeed" [minZoomLevel]="minZoomLevel" [maxZoomLevel]="maxZoomLevel"
					[panOnZoom]="panOnZoom" [autoZoom]="autoZoom" [autoCenter]="autoCenter" [center$]="center$">
					<ng-template #defsTemplate>
						<svg:marker id="arrow" viewBox="0 -5 10 10" refX="8" refY="0" markerWidth="4" markerHeight="4"
							orient="auto">
							<svg:path d="M0,-5L10,0L0,5" class="arrow-head" />
						</svg:marker>
					</ng-template>

					<ng-template #clusterTemplate let-cluster>
						<svg:g class="node cluster">
							<svg:rect rx="5" ry="5" [attr.width]="cluster.dimension.width"
								[attr.height]="cluster.dimension.height" [attr.fill]="cluster.data.color" />
						</svg:g>
					</ng-template>

					<ng-template #nodeTemplate let-node>
						<svg:g class="node" (click)="navigateToOperacion(node.id)" style="cursor: pointer">
							<svg:rect rx="5" [attr.width]="node.dimension.width" [attr.height]="node.dimension.height"
								[attr.fill]="node.data.colors.background" />
							<svg:text alignment-baseline="central" [attr.x]="10" font-weight="bold"
								[attr.y]="node.dimension.height / 2" [attr.fill]="node.data.colors.textColor">
								{{ node.label }}
							</svg:text>
						</svg:g>
					</ng-template>

					<ng-template #linkTemplate let-link>
						<svg:g class="edge">
							<svg:path class="line" stroke-width="2" marker-end="url(#arrow)"></svg:path>
							<svg:text class="edge-label" text-anchor="middle">
								<textPath class="text-path" [attr.href]="'#' + link.id" [style.dominant-baseline]="
												link.dominantBaseline
											" startOffset="50%">
									{{ link.label }}
								</textPath>
							</svg:text>
						</svg:g>
					</ng-template>
				</ngx-graph>
			</div>
		</div>
	</div>
	}
</div>
}